// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3L7aL","signatureButtonsRight":"ModalSign_signatureButtonsRight__3MYq7"};